const styles = ({ BREAKPOINTS }) => ({
  container: {
    maxWidth: '1320px',
    padding: '0 20px',
    marginLeft: 'auto',
    marginRight: 'auto',
    [`@media (max-width: ${BREAKPOINTS.XL})`]: {
      maxWidth: '1140px'
    },
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      padding: '0'
    }
  }
})

export default styles
